import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import OrganizationSelect from "components/select/OrganizationSelect/OrganizationSelect";
import type { SmartReport } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: SmartReport;
};

function SmartReportForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
            organization: item.organization?.id,
            media: item.media ? [item.media] : [],
          }
        : {},
    [item],
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="DocumentTextIcon"
      i18nNamespace="smart-reports"
      render={() => (
        <div className="white-box flex flex-col gap-4">
          <FormControl
            name="organization"
            title={t("smart-reports.organization")}
            type="custom"
            isSelect
            required
          >
            <OrganizationSelect />
          </FormControl>
          <FormControl
            name="media"
            title={t("smart-reports.media")}
            type="file"
            max={1}
            required
            acceptPdf
          />
        </div>
      )}
    />
  );
}

export default SmartReportForm;
